/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_EventInputs */

const en_admin_dashboard_event = /** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const nl_admin_dashboard_event = /** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const ro_admin_dashboard_event = /** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eveniment`)
};

/** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */
const de_admin_dashboard_event = en_admin_dashboard_event;

/** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */
const es_admin_dashboard_event = en_admin_dashboard_event;

/** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */
const fr_admin_dashboard_event = en_admin_dashboard_event;

/** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */
const it_admin_dashboard_event = en_admin_dashboard_event;

/** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */
const pt_br2_admin_dashboard_event = en_admin_dashboard_event;

/** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */
const pl_admin_dashboard_event = en_admin_dashboard_event;

/** @type {(inputs: Admin_Dashboard_EventInputs) => LocalizedString} */
const hu_admin_dashboard_event = en_admin_dashboard_event;

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Admin_Dashboard_EventInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_event = /** @type {((inputs?: Admin_Dashboard_EventInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_EventInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_event(inputs)
	if (locale === "de") return de_admin_dashboard_event(inputs)
	if (locale === "es") return es_admin_dashboard_event(inputs)
	if (locale === "fr") return fr_admin_dashboard_event(inputs)
	if (locale === "nl") return nl_admin_dashboard_event(inputs)
	if (locale === "it") return it_admin_dashboard_event(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_event(inputs)
	if (locale === "pl") return pl_admin_dashboard_event(inputs)
	if (locale === "hu") return hu_admin_dashboard_event(inputs)
	return ro_admin_dashboard_event(inputs)
});
export { admin_dashboard_event as "admin.dashboard.event" }